module.exports = "/img/_/_/_/assets/images/creeper/battle/rare//3.jpg?887effd0f2affa1381d1ade1fc55ad09";